import { LitElement as P, unsafeCSS as S, html as k } from "lit";
import { property as l, queryAssignedNodes as ne } from "lit/decorators.js";
import { classMap as x } from "lit/directives/class-map.js";
var ie = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
(function(i, e) {
  (function(s, t) {
    t();
  })(ie, function() {
    function s(n) {
      var r = !0, a = !1, c = null, w = {
        text: !0,
        search: !0,
        url: !0,
        tel: !0,
        email: !0,
        password: !0,
        number: !0,
        date: !0,
        month: !0,
        week: !0,
        time: !0,
        datetime: !0,
        "datetime-local": !0
      };
      function v(o) {
        return !!(o && o !== document && o.nodeName !== "HTML" && o.nodeName !== "BODY" && "classList" in o && "contains" in o.classList);
      }
      function G(o) {
        var se = o.type, N = o.tagName;
        return !!(N === "INPUT" && w[se] && !o.readOnly || N === "TEXTAREA" && !o.readOnly || o.isContentEditable);
      }
      function I(o) {
        o.classList.contains("focus-visible") || (o.classList.add("focus-visible"), o.setAttribute("data-focus-visible-added", ""));
      }
      function J(o) {
        o.hasAttribute("data-focus-visible-added") && (o.classList.remove("focus-visible"), o.removeAttribute("data-focus-visible-added"));
      }
      function Q(o) {
        o.metaKey || o.altKey || o.ctrlKey || (v(n.activeElement) && I(n.activeElement), r = !0);
      }
      function O(o) {
        r = !1;
      }
      function W(o) {
        v(o.target) && (r || G(o.target)) && I(o.target);
      }
      function Z(o) {
        v(o.target) && (o.target.classList.contains("focus-visible") || o.target.hasAttribute("data-focus-visible-added")) && (a = !0, window.clearTimeout(c), c = window.setTimeout(function() {
          a = !1;
        }, 100), J(o.target));
      }
      function ee(o) {
        document.visibilityState === "hidden" && (a && (r = !0), D());
      }
      function D() {
        document.addEventListener("mousemove", d), document.addEventListener("mousedown", d), document.addEventListener("mouseup", d), document.addEventListener("pointermove", d), document.addEventListener("pointerdown", d), document.addEventListener("pointerup", d), document.addEventListener("touchmove", d), document.addEventListener("touchstart", d), document.addEventListener("touchend", d);
      }
      function te() {
        document.removeEventListener("mousemove", d), document.removeEventListener("mousedown", d), document.removeEventListener("mouseup", d), document.removeEventListener("pointermove", d), document.removeEventListener("pointerdown", d), document.removeEventListener("pointerup", d), document.removeEventListener("touchmove", d), document.removeEventListener("touchstart", d), document.removeEventListener("touchend", d);
      }
      function d(o) {
        o.target.nodeName && o.target.nodeName.toLowerCase() === "html" || (r = !1, te());
      }
      document.addEventListener("keydown", Q, !0), document.addEventListener("mousedown", O, !0), document.addEventListener("pointerdown", O, !0), document.addEventListener("touchstart", O, !0), document.addEventListener("visibilitychange", ee, !0), D(), n.addEventListener("focus", W, !0), n.addEventListener("blur", Z, !0), n.nodeType === Node.DOCUMENT_FRAGMENT_NODE && n.host ? n.host.setAttribute("data-js-focus-visible", "") : n.nodeType === Node.DOCUMENT_NODE && (document.documentElement.classList.add("js-focus-visible"), document.documentElement.setAttribute("data-js-focus-visible", ""));
    }
    if (typeof window < "u" && typeof document < "u") {
      window.applyFocusVisiblePolyfill = s;
      var t;
      try {
        t = new CustomEvent("focus-visible-polyfill-ready");
      } catch {
        t = document.createEvent("CustomEvent"), t.initCustomEvent("focus-visible-polyfill-ready", !1, !1, {});
      }
      window.dispatchEvent(t);
    }
    typeof document < "u" && s(document);
  });
})();
try {
  document.body.querySelector(":focus-visible");
} catch {
}
const j = (i) => {
  class e extends i {
    constructor(...t) {
      super(...t);
    }
  }
  return e;
};
var ae = Object.defineProperty, re = Object.getOwnPropertyDescriptor, $ = (i, e, s, t) => {
  for (var n = t > 1 ? void 0 : t ? re(e, s) : e, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (n = (t ? a(e, s, n) : a(n)) || n);
  return t && n && ae(e, s, n), n;
};
class A extends j(P) {
  constructor() {
    super(), this.disabled = !1, this.autofocus = !1, this._tabIndex = 0, this.manipulatingTabindex = !1;
  }
  get tabIndex() {
    if (this.focusElement === this) {
      const s = this.hasAttribute("tabindex") ? parseFloat(this.getAttribute("tabindex")) : NaN;
      return isNaN(s) ? -1 : s;
    }
    const e = parseFloat(
      this.hasAttribute("tabindex") && this.getAttribute("tabindex") || "0"
    );
    return this.disabled || e < 0 ? -1 : this.focusElement ? this.focusElement.tabIndex : e;
  }
  set tabIndex(e) {
    if (this.manipulatingTabindex) {
      this.manipulatingTabindex = !1;
      return;
    }
    if (this.focusElement === this) {
      if (e !== this.tabIndex) {
        this._tabIndex = e;
        const s = this.disabled ? "-1" : `${e}`;
        this.setAttribute("tabindex", s);
      }
      return;
    }
    if (e === -1 ? this.addEventListener(
      "pointerdown",
      this.onPointerdownManagementOfTabIndex
    ) : (this.manipulatingTabindex = !0, this.removeEventListener(
      "pointerdown",
      this.onPointerdownManagementOfTabIndex
    )), e === -1 || this.disabled) {
      this.setAttribute("tabindex", "-1"), this.removeAttribute("focusable"), e !== -1 && this.manageFocusElementTabindex(e);
      return;
    }
    this.setAttribute("focusable", ""), this.hasAttribute("tabindex") ? this.removeAttribute("tabindex") : this.manipulatingTabindex = !1, this.manageFocusElementTabindex(e);
  }
  onPointerdownManagementOfTabIndex() {
    this.tabIndex === -1 && (this.tabIndex = 0, this.focus({ preventScroll: !0 }));
  }
  async manageFocusElementTabindex(e) {
    this.focusElement || await this.updateComplete, e === null ? this.focusElement.removeAttribute("tabindex") : this.focusElement.tabIndex = e;
  }
  get focusElement() {
    return this;
  }
  focus(e) {
    this.disabled || !this.focusElement || (this.focusElement !== this ? this.focusElement.focus(e) : HTMLElement.prototype.focus.apply(this, [e]));
  }
  blur() {
    const e = this.focusElement || this;
    e !== this ? e.blur() : HTMLElement.prototype.blur.apply(this);
  }
  click() {
    if (this.disabled)
      return;
    const e = this.focusElement || this;
    e !== this ? e.click() : HTMLElement.prototype.click.apply(this);
  }
  manageAutoFocus() {
    this.autofocus && (this.dispatchEvent(new KeyboardEvent("keydown", { code: "Tab" })), this.focusElement.focus());
  }
  firstUpdated(e) {
    super.firstUpdated(e), this.manageAutoFocus(), (!this.hasAttribute("tabindex") || this.getAttribute("tabindex") !== "-1") && this.setAttribute("focusable", "");
  }
  update(e) {
    e.has("disabled") && this.handleDisabledChanged(
      this.disabled,
      e.get("disabled")
    ), super.update(e);
  }
  updated(e) {
    super.updated(e), e.has("disabled") && this.disabled && this.blur();
  }
  async handleDisabledChanged(e, s) {
    const t = () => this.focusElement !== this && typeof this.focusElement.disabled < "u";
    e ? (this.manipulatingTabindex = !0, this.setAttribute("tabindex", "-1"), await this.updateComplete, t() ? this.focusElement.disabled = !0 : this.setAttribute("aria-disabled", "true")) : s && (this.manipulatingTabindex = !0, this.focusElement === this ? this.setAttribute("tabindex", `${this._tabIndex}`) : this.removeAttribute("tabindex"), await this.updateComplete, t() ? this.focusElement.disabled = !1 : this.removeAttribute("aria-disabled"));
  }
}
$([
  l({ type: Boolean, reflect: !0 })
], A.prototype, "disabled", 2);
$([
  l({ type: Boolean })
], A.prototype, "autofocus", 2);
$([
  l({ type: Number })
], A.prototype, "tabIndex", 1);
const oe = (i) => i.getRootNode().activeElement, le = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.pointer-events-none{pointer-events:none}.static{position:static}.absolute{position:absolute}.relative{position:relative}.left-0{left:0}.z-0{z-index:0}.m-0{margin:0}.mb-2{margin-bottom:.5rem}.box-border{box-sizing:border-box}.block{display:block}.inline{display:inline}.flex{display:flex}.hidden{display:none}.h-full{height:100%}.w-full{width:100%}.w-px{width:1px}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.cursor-default{cursor:default}.cursor-pointer{cursor:pointer}.resize{resize:both}.flex-col{flex-direction:column}.items-center{align-items:center}.justify-center{justify-content:center}.whitespace-nowrap{white-space:nowrap}.break-all{word-break:break-all}.border{border-width:1px}.border-b{border-bottom-width:1px}.border-b-4{border-bottom-width:4px}.border-solid{border-style:solid}.border-blue-070{border-color:#0a78f5}.border-neutral-070{border-color:#637e9c}.border-neutral-090{border-color:#b4c1cf}.border-transparent{border-color:transparent}.bg-neutral-090{background-color:#b4c1cf}.bg-neutral-140{background-color:#fff}.px-3{padding-left:.75rem;padding-right:.75rem}.pb-2{padding-bottom:.5rem}.pt-3{padding-top:.75rem}.font-sans{font-family:AmericanSans Var,Helvetica,Arial,sans-serif}.text-base{font-size:1rem}.text-sm{font-size:.875rem}.capitalize{text-transform:capitalize}.leading-5{line-height:1.25rem}.leading-6{line-height:1.5rem}.text-blue-060{color:#0860c4}.text-neutral-000{color:#101419}.text-neutral-010{color:#181e25}.text-neutral-060{color:#50657c}.text-neutral-090{color:#b4c1cf}.underline{text-decoration-line:underline}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.content-none{--tw-content: none;content:var(--tw-content)}.font-bold{font-weight:700;font-variation-settings:"wght" 700}.font-normal{font-weight:400;font-variation-settings:"wght" 400}[hidden]{display:none!important}.after\\:pointer-events-none:after{content:var(--tw-content);pointer-events:none}.after\\:absolute:after{content:var(--tw-content);position:absolute}.after\\:left-0:after{content:var(--tw-content);left:0}.after\\:top-0:after{content:var(--tw-content);top:0}.after\\:box-border:after{content:var(--tw-content);box-sizing:border-box}.after\\:h-full:after{content:var(--tw-content);height:100%}.after\\:w-full:after{content:var(--tw-content);width:100%}.after\\:border:after{content:var(--tw-content);border-width:1px}.after\\:border-solid:after{content:var(--tw-content);border-style:solid}.after\\:border-transparent:after{content:var(--tw-content);border-color:transparent}.hover\\:bg-neutral-130:hover{background-color:#f9fafb}.hover\\:text-blue-060:hover{color:#0860c4}.active\\:bg-neutral-120:active{background-color:#f3f5f7}.active\\:text-blue-060:active{color:#0860c4}
`, de = S(le), E = "aileron-color-scheme", M = "aileron-color-scheme-change", R = (i) => {
  class e extends i {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (t) => {
        t.detail ? this.setAttribute(E, t.detail) : this.removeAttribute(E);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        M,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const t = document.documentElement.getAttribute(
        E
      );
      t && this.setAttribute(E, t);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        M,
        this.handleSchemeSwitch
      );
    }
  }
  return e.styles = [
    de,
    i.styles ?? []
  ], e;
};
function F(i, e) {
  const s = {
    waitUntilFirstUpdate: !1,
    ...e
  };
  return (t, n) => {
    const { update: r } = t;
    if (i in t) {
      const a = i;
      t.update = function(c) {
        if (c.has(a)) {
          const w = c.get(a), v = this[a];
          w !== v && (!s.waitUntilFirstUpdate || this.hasUpdated) && this[n](
            w,
            v
          );
        }
        r.call(this, c);
      };
    }
  };
}
const z = `:host ::slotted(*){vertical-align:top}:host([disabled]) ::slotted(.adc-tab-panel){display:none}:host(.adc-tabs[disabled]) ::slotted(.adc-tab){--adc-tab-icon-fill: #b4c1cf}:host(.adc-tab[selected]){--adc-tab-icon-fill: #0860c4}:host(.adc-tab:focus-within),:host(.adc-tab.focus-visible) [role=tab]{outline:2px solid #0a78f5;outline-offset:-2px}:host(.adc-tab){flex:1 1 0;width:0;transition:background .15s cubic-bezier(.4,0,.2,1) 0s;--adc-tab-icon-fill: #101419}:host(.adc-tab) ::slotted(.adc-icon){margin-bottom:.25rem;--icon-fill: var(--adc-tab-icon-fill)}:host(.adc-tab[disabled]){pointer-events:none;--adc-tab-icon-fill: #b4c1cf}
`;
var ce = Object.defineProperty, ue = Object.getOwnPropertyDescriptor, b = (i, e, s, t) => {
  for (var n = t > 1 ? void 0 : t ? ue(e, s) : e, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (n = (t ? a(e, s, n) : a(n)) || n);
  return t && n && ce(e, s, n), n;
};
const he = R(P), be = {
  horizontal: ["ArrowLeft", "ArrowRight"]
}, U = "transform: translateX(0px) scaleX(0) scaleY(0)";
class u extends A {
  constructor() {
    super(...arguments), this.auto = !1, this.disabled = !1, this.direction = "horizontal", this.selectionIndicatorStyle = U, this.shouldAnimate = !1, this.underline = !1, this._selected = "", this.tabs = [], this.shouldSetFocusVisible = !1, this.manageFocusinType = () => {
      if (this.shouldSetFocusVisible)
        return;
      const e = () => {
        this.shouldSetFocusVisible = !1, this.removeEventListener("focusin", e);
      };
      this.addEventListener("focusin", e);
    }, this.onClick = (e) => {
      const s = e.target;
      this.disabled || s.disabled || s.readOnly || (this.shouldAnimate = !0, s?.getAttribute("value") !== this.selected && this.selectTarget(s.getAttribute("value")), this.shouldSetFocusVisible && e.composedPath()[0] !== this && (this.dispatchEvent(
        new KeyboardEvent("keydown", {
          code: "Tab"
        })
      ), s.focus()));
    }, this.onKeyDown = (e) => {
      if (e.code === "Enter" || e.code === "Space") {
        e.preventDefault();
        const s = e.target;
        s.getAttribute("value") !== this.selected && this.selectTarget(s.getAttribute("value"));
      }
    }, this.onSelectedChanged = (e) => {
      const s = e.target;
      s?.getAttribute("value") !== this.selected && s.selected && this.selectTarget(s.value);
    }, this.updateCheckedState = () => {
      if (this.tabs.length || (this.tabs = [
        ...this.querySelectorAll(".adc-tab")
      ]), this.tabs.forEach((e) => {
        e.removeAttribute("selected");
      }), this.selected) {
        const e = this.tabs.find(
          (s) => s.value === this.selected
        );
        e ? e.selected = !0 : this.selected = "";
      } else {
        const e = this.tabs[0];
        e && e.renderRoot.querySelector("button").setAttribute("tabindex", "0");
      }
      this.updateSelectionIndicator(), this.tabChangeResolver();
    }, this.updateSelectionIndicator = async () => {
      const e = this.tabs.find((n) => n.selected);
      if (!e) {
        this.selectionIndicatorStyle = U;
        return;
      }
      await Promise.all([
        e.updateComplete,
        document.fonts ? document.fonts.ready : Promise.resolve()
      ]);
      const s = e.getBoundingClientRect(), t = this.getBoundingClientRect();
      if (this.direction === "horizontal") {
        const n = s.width, r = s.left - t.left;
        this.selectionIndicatorStyle = `transform: translateX(${r}px) scaleX(${n});`;
      } else {
        const n = s.height, r = s.top - t.top;
        this.selectionIndicatorStyle = `transform: translateY(${r}px) scaleY(${n});`;
      }
    }, this.tabChangePromise = Promise.resolve(), this.tabChangeResolver = function() {
    };
  }
  get selected() {
    return this._selected;
  }
  set selected(e) {
    const s = this.selected;
    e !== s && (this._selected = e, this.shouldUpdateCheckedState(), this.requestUpdate("selected", s));
  }
  get focusElement() {
    const e = this.tabs.find(
      (t) => !t.disabled && (t.selected || t.value === this.selected)
    );
    return e || this.tabs.find((t) => !t.disabled) || this;
  }
  manageAutoFocus() {
    const s = [...this.children].map((t) => typeof t.updateComplete < "u" ? t.updateComplete : Promise.resolve());
    Promise.all(s).then(
      () => super.manageAutoFocus()
    );
  }
  managePanels({ target: e }) {
    e.assignedElements().map((t) => {
      const { value: n, id: r } = t, a = this.querySelector(`[role="tab"][value="${n}"]`);
      a && (a.setAttribute("aria-controls", r), t.setAttribute("aria-labelledby", a.id)), t.selected = n === this.selected;
    });
  }
  handleUnderlineChange() {
    this.tabs.forEach((e) => {
      e.underline = this.underline;
    });
  }
  handleDisabledChange() {
    this.tabs.forEach((e) => {
      e.disabled = this.disabled;
    });
  }
  render() {
    return k`
      <div
        part="tabs-container"
        @click=${this.onClick}
        @keydown=${this.onKeyDown}
        @mousedown=${this.manageFocusinType}
        @focusin=${this.startListeningToKeyboard}
        class="flex m-0 mb-2 justify-center relative z-0 bg-neutral-140 border-b ${x(
      {
        "border-solid": !this.disabled,
        "border-neutral-090": this.underline,
        "border-transparent": !this.underline || this.disabled
      }
    )}"
        id="tab-list"
        role="tablist"
      >
        <slot
          @slotchange=${this.onSlotChange}
          @adc-change=${this.onSelectedChanged}
        ></slot>
        <div
          id="selectedIndication"
          part="tab-indicator"
          class=${x({
      absolute: !0,
      "w-px": !0,
      "left-0": !0,
      "z-0": !0,
      "bg-neutral-090": this.disabled,
      "pointer-events-none": !this.shouldAnimate
    })}
          style=${this.selectionIndicatorStyle}
          role="presentation"
        ></div>
      </div>
      <slot name="adc-tab-panel" @slotchange=${this.managePanels}></slot>
    `;
  }
  firstUpdated(e) {
    super.firstUpdated(e);
    const s = this.querySelector("[selected]");
    s && this.selectTarget(s.getAttribute("value"));
  }
  updated(e) {
    if (super.updated(e), e.has("selected")) {
      if (e.get("selected")) {
        const t = this.querySelector(
          `[role="tabpanel"][value="${e.get("selected")}"]`
        );
        t && (t.selected = !1);
      }
      const s = this.querySelector(
        `[role="tabpanel"][value="${this.selected}"]`
      );
      s && (s.selected = !0);
    }
    e.has("disabled") && (this.disabled ? this.setAttribute("aria-disabled", "true") : this.removeAttribute("aria-disabled")), !this.shouldAnimate && typeof e.get("shouldAnimate") < "u" && (this.shouldAnimate = !0);
  }
  startListeningToKeyboard() {
    this.addEventListener("keydown", this.handleKeydown), this.shouldSetFocusVisible = !0;
    const e = this.querySelector("[selected]");
    e && (e.renderRoot.querySelector("button").tabIndex = -1);
    const s = () => {
      this.removeEventListener("keydown", this.handleKeydown), this.shouldSetFocusVisible = !1;
      const t = this.querySelector("[selected]");
      t && (t.renderRoot.querySelector("button").tabIndex = 0), this.removeEventListener("focusout", s);
    };
    this.addEventListener("focusout", s);
  }
  handleKeydown(e) {
    const { code: s } = e, t = [...be[this.direction]];
    if (!t.includes(s))
      return;
    e.preventDefault();
    const n = oe(this);
    let r = this.tabs.indexOf(n);
    r += s === t[0] ? -1 : 1;
    const a = this.tabs[(r + this.tabs.length) % this.tabs.length];
    a.renderRoot.querySelector("button").focus(), this.auto && (this.selected = a.value);
  }
  selectTarget(e) {
    if (e) {
      const s = this.selected;
      this.selected = e, this.dispatchEvent(
        new Event("change", {
          cancelable: !0
        })
      ) || (this.selected = s);
    }
  }
  /**
   * @private
   */
  onSlotChange() {
    this.tabs = [
      ...this.querySelectorAll(".adc-tab")
    ], this.shouldUpdateCheckedState();
  }
  /**
   * @private
   */
  shouldUpdateCheckedState() {
    this.tabChangeResolver(), this.tabChangePromise = new Promise(
      (e) => this.tabChangeResolver = e
    ), setTimeout(this.updateCheckedState);
  }
  async getUpdateComplete() {
    const e = await super.getUpdateComplete();
    return await this.tabChangePromise, e;
  }
  connectedCallback() {
    this.classList.add("adc-tabs"), super.connectedCallback(), window.addEventListener("resize", this.updateSelectionIndicator), "fonts" in document && document.fonts.addEventListener("loadingdone", this.updateSelectionIndicator);
  }
  disconnectedCallback() {
    window.removeEventListener("resize", this.updateSelectionIndicator), "fonts" in document && document.fonts.removeEventListener("loadingdone", this.updateSelectionIndicator), super.disconnectedCallback();
  }
}
u.styles = [he.styles || [], S(z)];
b([
  l({ type: Boolean })
], u.prototype, "auto", 2);
b([
  l({ type: Boolean, reflect: !0 })
], u.prototype, "disabled", 2);
b([
  l({ type: String, reflect: !1 })
], u.prototype, "direction", 2);
b([
  l({ attribute: !1 })
], u.prototype, "selectionIndicatorStyle", 2);
b([
  l({ attribute: !1 })
], u.prototype, "shouldAnimate", 2);
b([
  l({ type: Boolean, reflect: !0 })
], u.prototype, "underline", 2);
b([
  l({ reflect: !0 })
], u.prototype, "selected", 1);
b([
  F("underline")
], u.prototype, "handleUnderlineChange", 1);
b([
  F("disabled")
], u.prototype, "handleDisabledChange", 1);
try {
  customElements.define("adc-tabs", u);
} catch {
}
function fe(i) {
  try {
    customElements.define(`${i}-tabs`, class extends u {
    });
  } catch {
  }
}
const pe = (i) => {
  class e extends i {
    constructor(...t) {
      super(...t), this.fontLink = "https://www.aa.com/fonts/css?family=american-sans-variable";
      const n = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(n.getElementsByTagName("link")).findIndex(
        (c) => c.href === this.fontLink
      ) === -1) {
        const c = document.createElement("link");
        c.href = this.fontLink, c.rel = "stylesheet", document.head.appendChild(c);
      }
    }
  }
  return e;
}, L = R(pe(P));
var me = Object.defineProperty, we = Object.getOwnPropertyDescriptor, T = (i, e, s, t) => {
  for (var n = t > 1 ? void 0 : t ? we(e, s) : e, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (n = (t ? a(e, s, n) : a(n)) || n);
  return t && n && me(e, s, n), n;
};
const p = class q extends L {
  constructor() {
    super(...arguments), this.selected = !1, this.value = "";
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-tab-panel");
  }
  render() {
    return k`<div
      part="tab-panel"
      class="font-sans font-normal text-base leading-6 bg-neutral-140 text-neutral-000 box-border content-none after:absolute after:box-border after:w-full after:h-full after:top-0 after:left-0 after:border after:border-transparent after:border-solid after:pointer-events-none ${x(
      { block: this.selected, hidden: !this.selected }
    )}"
    >
      <slot></slot>
    </div>`;
  }
  /**
   * Sets a11y role and slot for use with the parent
   * component, tabs. If there isn't an id, one is generated.
   */
  firstUpdated() {
    this.slot = "adc-tab-panel", this.setAttribute("role", "tabpanel"), this.tabIndex = 0, this.hasAttribute("id") || (this.id = `adc-tab-panel-${q.instanceCount++}`);
  }
  /**
   * Sets aria-hidden and tabindex based on tab visibility.
   * @param changes
   */
  updated(e) {
    e.has("selected") && (this.selected ? (this.removeAttribute("aria-hidden"), this.tabIndex = 0) : (this.setAttribute("aria-hidden", "true"), this.tabIndex = -1));
  }
};
p.styles = [L.styles || [], S(z)];
p.instanceCount = 0;
T([
  l({ type: Boolean, reflect: !0 })
], p.prototype, "selected", 2);
T([
  l({ type: String, reflect: !0 })
], p.prototype, "value", 2);
T([
  l()
], p.prototype, "id", 2);
T([
  l({ type: Number })
], p.prototype, "tabIndex", 2);
let H = p;
try {
  customElements.define("adc-tab-panel", H);
} catch {
}
function ve(i) {
  try {
    customElements.define(`${i}-tab-panel`, class extends H {
    });
  } catch {
  }
}
function f(i, e, s) {
  const t = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...s
  });
  return i.dispatchEvent(t), t;
}
const C = Symbol("slotElementObserver"), K = Symbol("startObserving"), g = Symbol("slotContentIsPresent");
function ge(i, e) {
  var s;
  const t = Array.isArray(e) ? e : [e];
  class n extends i {
    constructor(...a) {
      super(...a), this[s] = /* @__PURE__ */ new Map(), this.managePresenceObservedSlot = () => {
        t.forEach((c) => {
          this[g].set(
            c,
            !!this.querySelector(c)
          );
        }), this.requestUpdate();
      };
    }
    get slotContentIsPresent() {
      if (t.length === 1)
        return this[g].get(t[0]) || !1;
      throw new Error(
        "Multiple selectors provided to `ObserveSlotPresence` use `getSlotContentPresence(selector: string)` instead."
      );
    }
    getSlotContentPresence(a) {
      if (this[g].has(a))
        return this[g].get(a) || !1;
      throw new Error("The provided selector `` is not being observed.");
    }
    [(s = g, K)]() {
      const a = { childList: !0, subtree: !0 };
      this[C] || (this[C] = new MutationObserver(
        this.managePresenceObservedSlot
      )), this[C].observe(this, a), this.managePresenceObservedSlot();
    }
    connectedCallback() {
      super.connectedCallback(), this[K]();
    }
    disconnectedCallback() {
      this[C].disconnect(), super.disconnectedCallback();
    }
  }
  return n;
}
var ye = Object.defineProperty, xe = Object.getOwnPropertyDescriptor, B = (i, e, s, t) => {
  for (var n = t > 1 ? void 0 : t ? xe(e, s) : e, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (n = (t ? a(e, s, n) : a(n)) || n);
  return t && n && ye(e, s, n), n;
};
const y = Symbol("slotElementObserver"), _ = Symbol("assignedNodes"), V = Symbol("startObserving");
function Ee(i, e) {
  var s;
  class t extends i {
    constructor(...r) {
      super(...r), this.slotHasContent = !1;
    }
    manageTextObservedSlot() {
      if (!this[_])
        return;
      const r = [...this[_]].filter(
        (a) => a.tagName ? !0 : a.textContent ? a.textContent.trim() : !1
      );
      this.slotHasContent = r.length > 0;
    }
    firstUpdated(r) {
      super.firstUpdated(r), this.manageTextObservedSlot();
    }
    [(s = _, V)]() {
      const r = { CharacterData: !0, subtree: !0 };
      if (!this[y]) {
        const a = (c) => {
          for (const w of c)
            w.type === "characterData" && this.manageTextObservedSlot();
        };
        this[y] = new MutationObserver(a);
      }
      this[y].observe(this, r);
    }
    connectedCallback() {
      super.connectedCallback(), this[V];
    }
    disconnectedCallback() {
      this[y] && this[y].disconnect(), super.disconnectedCallback();
    }
  }
  return B([
    l({ type: Boolean, attribute: !1 })
  ], t.prototype, "slotHasContent", 2), B([
    ne(e, !0)
  ], t.prototype, s, 2), t;
}
var Ce = Object.defineProperty, ke = Object.getOwnPropertyDescriptor, m = (i, e, s, t) => {
  for (var n = t > 1 ? void 0 : t ? ke(e, s) : e, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (n = (t ? a(e, s, n) : a(n)) || n);
  return t && n && Ce(e, s, n), n;
};
const h = class X extends j(
  Ee(
    ge(L, '[slot="icon"]'),
    ""
  )
) {
  constructor() {
    super(...arguments), this.disabled = !1, this.selected = !1, this.value = "", this.underline = !1, this.subLabel = "", this.readOnly = !1;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-tab");
  }
  /**
   * @fires click - listens for a click event on the button.
   */
  _handleClick() {
    f(this, "adc-click");
  }
  _handleBlur() {
    f(this, "adc-blur");
  }
  _handleFocus() {
    f(this, "adc-focus");
  }
  _handleKeydown() {
    f(this, "adc-keydown");
  }
  _handleKeyup() {
    f(this, "adc-keyup");
  }
  _handleChange() {
    this.selected ? f(this, "adc-open") : f(this, "adc-close"), f(this, "adc-change");
  }
  render() {
    return k`<button
      role="tab"
      part="tab"
      id="adc-tab-${X.instanceCount++}"
      class="font-sans font-bold text-base leading-6 bg-neutral-140 flex flex-col items-center px-3 pt-3 pb-2 box-border capitalize cursor-pointer w-full hover:bg-neutral-130 hover:text-blue-060 active:bg-neutral-120 active:text-blue-060 border-b-4 border-solid h-full justify-center break-all ${x(
      {
        "text-neutral-010": !this.selected && !this.disabled || this.readOnly,
        "cursor-default": this.disabled,
        "pointer-events-none": this.disabled || this.readOnly,
        "text-blue-060": this.selected && !this.disabled,
        "text-neutral-090": this.disabled,
        "border-blue-070": this.selected,
        "border-transparent": (!this.selected || this.disabled) && !this.readOnly,
        "border-neutral-070": this.readOnly
      }
    )}"
      ?disabled=${this.disabled || this.readOnly}
      aria-disabled=${this.disabled ? "true" : "false"}
      aria-selected=${this.selected ? "true" : "false"}
      tabindex=${this.selected ? "0" : "-1"}
      @click=${this._handleClick}
      @focus=${this._handleFocus}
      @blur=${this._handleBlur}
      @keydown=${this._handleKeydown}
      @keyup=${this._handleKeyup}
    >
      <slot></slot>
      ${this.subLabel ? k`
            <label
              part="tab-label"
              class="font-sans font-normal text-sm leading-5 whitespace-nowrap ${x(
      {
        "text-neutral-090": this.disabled,
        "text-neutral-060": this.readOnly || !this.disabled
      }
    )}"
              >${this.subLabel}</label
            >
          ` : ""}
    </button>`;
  }
};
h.styles = [L.styles || [], S(z)];
h.instanceCount = 0;
m([
  l({ type: Boolean, reflect: !0 })
], h.prototype, "disabled", 2);
m([
  l({ type: Boolean, reflect: !0 })
], h.prototype, "selected", 2);
m([
  l({ type: String, reflect: !0 })
], h.prototype, "value", 2);
m([
  l({ type: Boolean, reflect: !0 })
], h.prototype, "underline", 2);
m([
  l({ type: String, reflect: !0, attribute: "sub-label" })
], h.prototype, "subLabel", 2);
m([
  l({ type: Boolean, reflect: !0, attribute: "read-only" })
], h.prototype, "readOnly", 2);
m([
  F("selected")
], h.prototype, "_handleChange", 1);
let Y = h;
try {
  customElements.define("adc-tab", Y);
} catch {
}
function Se(i) {
  try {
    customElements.define(`${i}-tab`, class extends Y {
    });
  } catch {
  }
}
function Oe(i) {
  try {
    fe(i), ve(i), Se(i);
  } catch {
  }
}
export {
  Y as Tab,
  H as TabPanel,
  u as Tabs,
  Oe as registerComponent,
  Se as registerTab,
  ve as registerTabPanel,
  fe as registerTabs
};
